import React, {useEffect, useState} from "react";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle, Grid,
    Table,
    TableCell,
    TableRow,
    TextField
} from "@material-ui/core";
//import DateTimePicker from "react-datetime-picker/src/DateTimePicker";
import CgSelect from "../core/CgSelect";
import axios from "axios";
import dateHelper from "../core/dateHelper";

function parseDetailsToGetUserAgent(item){
    if(!item){
        return '!item';
    }

    if(!item.Details){
        return '!item.Details';
    }

    const str = item.Details.replace('\u0022','"');
    const json = JSON.parse(str);

    if(!json){
        return '!json';
    }
    if(!json.browser){
        return '!json.browser';
    }

    return json.browser['user-agent'];
}

function parseDetailsToGetIP(item){
    if(!item){
        return '!item';
    }

    if(!item.Details){
        return '!item.Details';
    }

    const str = item.Details.replace('\u0022','"');
    const json = JSON.parse(str);

    if(!json){
        return '!json';
    }
    if(!json.browser){
        return '!json.browser';
    }

    return json.browser['address'];
}

export function TimelineDialog(props){
    const {onDock} = props;
    const [open,setOpen] = useState(false);
    const [timelineItems, setTimelineItems] = useState([]);
    const [onOk, setOnOk] = useState(() => () => alert("no onOk set"));
    const show = (timelineItems) => {
        setOpen(true);
        setTimelineItems(timelineItems);
    };

    useEffect(() => {
        onDock(show);
    },[]); // eslint-disable-line react-hooks/exhaustive-deps

    return <Dialog open={open} onclose={() => setOpen(false)}
    >
        <DialogTitle>Timeline {(timelineItems || []).length}</DialogTitle>
        <DialogContent>
            <DialogContentText>

            </DialogContentText>

                    <Table >
                        <TableRow>

                            <TableCell>
                                Time
                            </TableCell>
                            <TableCell>
                                Event
                            </TableCell>
                            <TableCell>
                                Agent
                            </TableCell>
                            <TableCell>
                                IP
                            </TableCell>
                        </TableRow>
                        {
                            (timelineItems || []).map(item => <TableRow>

                                <TableCell>
                                    {dateHelper.toShortDateTime(item.Time)}
                                </TableCell>
                                <TableCell>
                                    {item.Message}
                                </TableCell>
                                <TableCell>
                                    {
                                        parseDetailsToGetUserAgent(item)
                                    }

                                </TableCell>
                                <TableCell>
                                    {
                                        parseDetailsToGetIP(item)
                                    }
                                </TableCell>
                            </TableRow>)
                        }
                    </Table>

        </DialogContent>
        <DialogActions>
            <Button onClick={() => setOpen(false)}>OK</Button>
        </DialogActions>
    </Dialog>
}